import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import PageChrome from '../../components/layout/PageChrome';
import ProspectiveStudentCard from '../../components/cards/ProspectiveStudentCard';
import HolidayModal from '../../components/ui/HolidayModal';
import TourBookingForm from '../../components/forms/TourBookingForm';
import GetConnectedForm from '../../components/forms/GetConnectedForm';
import prospectiveStudents from '../../cms/prospective-students.json';
import '../../css/student-life/ProspectiveStudents.css';

const prospectiveStudentInfo = prospectiveStudents;
const prospectiveStudentOpportunities = prospectiveStudents.opportunities || [];
const shabbatonsData = prospectiveStudents.shabbatons || [];

const ProspectiveStudents = () => {
  const [selectedShabbaton, setSelectedShabbaton] = useState(null);
  const [showTourForm, setShowTourForm] = useState(false);
  const [showGetConnectedForm, setShowGetConnectedForm] = useState(false);
  const { shabbatonId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  const featuredOpportunities = prospectiveStudentOpportunities.filter(opportunity => opportunity.featured);
  const otherOpportunities = prospectiveStudentOpportunities.filter(opportunity => !opportunity.featured);

  // Handle route-based shabbaton opening
  useEffect(() => {
    if (shabbatonId) {
      const shabbatonMap = {
        'fall': 'fall-shabbaton',
        'spring': 'spring-shabbaton'
      };
      const actualId = shabbatonMap[shabbatonId];
      const shabbaton = shabbatonsData.find(s => s.id === actualId);
      if (shabbaton) {
        setSelectedShabbaton(shabbaton);
      }
    } else {
      setSelectedShabbaton(null);
    }
  }, [shabbatonId]);

  // Handle tour form opening based on route
  useEffect(() => {
    if (location.pathname === '/schedule-tour') {
      setShowTourForm(true);
    } else {
      setShowTourForm(false);
    }
  }, [location.pathname]);

  const handleTourClick = () => {
    if (location.pathname !== '/schedule-tour') {
      navigate('/schedule-tour');
    }
    setShowTourForm(true);
  };

  const handleGetConnectedClick = () => {
    // Just show the modal, don't navigate away from this page
    setShowGetConnectedForm(true);
  };

  const closeTourForm = () => {
    setShowTourForm(false);
    navigate('/prospective-students');
  };

  const closeGetConnectedForm = () => {
    setShowGetConnectedForm(false);
  };

  const closeShabbatonModal = () => {
    setSelectedShabbaton(null);
    navigate('/prospective-students');
  };

  return (
    <>
      <PageChrome
        title={prospectiveStudentInfo.title}
        subtitle={prospectiveStudentInfo.subtitle}
        intro={[prospectiveStudentInfo.description, prospectiveStudentInfo.welcomeMessage].filter(
          (item) => item != null && item !== ''
        )}
      >
        <section className="prospective-students-page-section">
          <div className="prospective-students-page-featured">
            <h2>Get Started</h2>
            <div className="prospective-students-page-grid">
              {featuredOpportunities.map((opportunity) => (
                <ProspectiveStudentCard 
                  key={opportunity.id} 
                  opportunity={opportunity}
                  onTourClick={opportunity.title === "Schedule a Tour" ? handleTourClick : undefined}
                  onGetConnectedClick={opportunity.title === "Get Connected" ? handleGetConnectedClick : undefined}
                />
              ))}
            </div>
          </div>
          
          {otherOpportunities.length > 0 && (
            <div className="prospective-students-page-other">
              <h2>Learn More</h2>
              <div className="prospective-students-page-grid">
                {otherOpportunities.map((opportunity) => (
                  <ProspectiveStudentCard 
                    key={opportunity.id} 
                    opportunity={opportunity}
                    onTourClick={opportunity.title === "Schedule a Tour" ? handleTourClick : undefined}
                    onGetConnectedClick={opportunity.title === "Get Connected" ? handleGetConnectedClick : undefined}
                  />
                ))}
              </div>
            </div>
          )}
        </section>
      </PageChrome>

      {showTourForm && <TourBookingForm onClose={closeTourForm} />}
      {showGetConnectedForm && <GetConnectedForm onClose={closeGetConnectedForm} />}
      <HolidayModal holiday={selectedShabbaton} onClose={closeShabbatonModal} />
    </>
  );
};

export default ProspectiveStudents; 